import React from 'react';
import PropTypes from 'prop-types';

import { dimensions } from 'styles/provider';

/*
  A utility element for providing automatic vertical centering for elements.
  The reason for its existence is that flexbox is not yet fully supported in IE and
  the CSS default verticalAlign is a joke.

  Takes the following arguments:
  - wrapperHeight [String]: the height (in px, rem, etc.) based on which we are centering (required).
    E.g. If you want to center something inside a div that has a height of 50px, set this to 50px.
  - lineHeight [String]: the lineheight we want to have for the centered content
    default is the general lineHeight in config.
  - children [React Node]: the wrapped elements, can be whatever, but single elements are most reliable.
*/

const VerticalMiddler = ({ wrapperHeight, lineHeight = dimensions.defaultLineHeight, children }) => (
  <div style={{ lineHeight: wrapperHeight, height: wrapperHeight }}>
    <div style={{ lineHeight: 0, verticalAlign: 'middle', display: 'inline-block' }}>
      <div style={{ lineHeight }} children={children} />
    </div>
  </div>
);

VerticalMiddler.propTypes = {
  wrapperHeight: PropTypes.string,
  lineHeight: PropTypes.string,
  children: PropTypes.node,
};

export default VerticalMiddler;
